import { render, staticRenderFns } from "./SubResourceCreatorModal.vue?vue&type=template&id=b17b07aa&scoped=true&lang=pug&"
import script from "./SubResourceCreatorModal.vue?vue&type=script&lang=js&"
export * from "./SubResourceCreatorModal.vue?vue&type=script&lang=js&"
import style0 from "./SubResourceCreatorModal.vue?vue&type=style&index=0&id=b17b07aa&scoped=true&lang=stylus&"
import style1 from "./SubResourceCreatorModal.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b17b07aa",
  null
  
)

export default component.exports